import React from "react";
import { motion } from "framer-motion";
import HeaderSection from "./HeaderSection";
import LanguageSupportTable from "./LanguageSupportTable";

const SectionFour = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="flex flex-col items-center lg:m-24 m-12"
    >
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
        className="flex-grow w-full"
      >
        <HeaderSection />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        viewport={{ once: true }}
        className="flex-grow w-full"
      >
        <LanguageSupportTable />
      </motion.div>
    </motion.div>
  );
};

export default SectionFour;
